import { atomWithStorage } from 'jotai/utils'

import {
  DEFAULT_OPTION_COLUMNS,
  DEFAULT_OPTION_COLUMNS_ORDER,
  OptionTableColumn,
} from '@/features/chart/lib/configs/option-setting-config'
import { STORAGE_KEYS } from '@/lib/configs/storage-config'
import { safeStorage } from '@/state/storage'

export type OptionTableConfig = {
  columns: OptionTableColumn
  columnsOrder: number[]
}

export const optionTableConfigAtom = atomWithStorage<OptionTableConfig>(
  STORAGE_KEYS.optionTable.config,
  {
    columns: DEFAULT_OPTION_COLUMNS,
    columnsOrder: DEFAULT_OPTION_COLUMNS_ORDER,
  },
  safeStorage,
  { getOnInit: true }
)
